import { axiosInstance } from '../api';
import { convertAutocompleteToServerRequest } from 'data/apiRequests/convertAutocompleteToServerRequest';

export default function(searchTerm) {
    const searchString = convertAutocompleteToServerRequest(searchTerm);

    return axiosInstance.get(`/fhir/Practitioner?_count=5${searchString}`);
}